import { render, staticRenderFns } from "./pos.vue?vue&type=template&id=a3bf1468&scoped=true&"
import script from "./pos.vue?vue&type=script&lang=js&"
export * from "./pos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bf1468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3bf1468')) {
      api.createRecord('a3bf1468', component.options)
    } else {
      api.reload('a3bf1468', component.options)
    }
    module.hot.accept("./pos.vue?vue&type=template&id=a3bf1468&scoped=true&", function () {
      api.rerender('a3bf1468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/pos/pos.vue"
export default component.exports